import React from "react";
import LegalLayout from "./LegalLayout";
import { openSettings } from "../lib/consent";

export default function PoliticaCookiesPage() {
  return (
    <LegalLayout
      title="Política de cookies"
      updated="29 de septiembre de 2026"
      testid="politica-cookies-page"
    >
      <h2>Qué son</h2>
      <p>
        Las cookies son pequeños archivos que se guardan en tu dispositivo al navegar y
        permiten recordar información sobre tu visita.
      </p>

      <h2>Cookies que usamos</h2>
      <div className="legal-table-wrap">
        <table className="legal-table">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Para qué</th>
              <th>¿Necesita tu consentimiento?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Técnicas y necesarias</td>
              <td>
                Funcionamiento básico de la web, recordar tu elección de cookies, acceso al
                panel
              </td>
              <td>No</td>
            </tr>
            <tr>
              <td>Analíticas</td>
              <td>Saber cuántas personas visitan la web y qué páginas leen</td>
              <td>Sí</td>
            </tr>
            <tr>
              <td>Publicitarias (píxel de Meta)</td>
              <td>
                Medir la eficacia de los anuncios y mostrarte contenidos relevantes en
                Instagram y Facebook
              </td>
              <td>Sí</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Las cookies analíticas y publicitarias <strong>no se instalan hasta que las aceptas</strong>{" "}
        en el banner. Puedes aceptarlas, rechazarlas o configurarlas, y cambiar tu decisión en
        cualquier momento desde el enlace{" "}
        <button
          type="button"
          onClick={openSettings}
          className="legal-inline-link"
          data-testid="cookies-page-open-settings"
        >
          “Configurar cookies”
        </button>{" "}
        del pie de página.
      </p>

      <h2>Cómo desactivarlas desde tu navegador</h2>
      <p>
        También puedes bloquear o eliminar las cookies desde la configuración de Chrome,
        Safari, Firefox o Edge.
      </p>

      <h2>Actualizaciones</h2>
      <p>
        Esta política puede actualizarse. Última actualización: 29 de septiembre de 2026.
      </p>
    </LegalLayout>
  );
}
